/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { CeproDocCreateRequest } from '../types/CeproDocCreate';
import type { CeproDocCreateResponse } from '../types/CeproDocCreate';

export type CeproDocsCheckDmvsPendingPozadavkyCreateRequest = CeproDocCreateRequest;
export type CeproDocsCheckDmvsPendingPozadavkyCreateResponse = CeproDocCreateResponse;

export type CeproDocsCheckDmvsPendingPozadavkyCreateQuery = {};

/**
 * POST /dmx-server/cepro_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: cepro_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocCreate'
 *     description: ''
 * ```
 */
export const ceproDocsCheckDmvsPendingPozadavkyCreateOperation = (
  rest?: CeproDocsCheckDmvsPendingPozadavkyCreateQuery | null,
) =>
  ({
    method: 'POST',
    path: `/dmx-server/cepro_docs/check_dmvs_pending_pozadavky/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/check_dmvs_pending_pozadavky/' };
  };

/**
 * POST /dmx-server/cepro_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: cepro_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocCreate'
 *     description: ''
 * ```
 */
export const ceproDocsCheckDmvsPendingPozadavkyCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: CeproDocsCheckDmvsPendingPozadavkyCreateQuery;
  request: CeproDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<CeproDocCreateResponse>> => {
  const operation = ceproDocsCheckDmvsPendingPozadavkyCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
